/* * Version: 3.1.0
 * Letzte Änderung: 16.09.2026, 12:28
 * Änderungshistorie: Dynamische BaseURL für Docker/Dev-Umgebung hinzugefügt und Axios-Interceptor für JWT-Authentifizierung (Admin-Bereich) integriert.
 * Copyright: BAIT-Tech
 */
import axios from 'axios';

// =============================================================================
//  UMGEBUNGS-ERKENNUNG (Dev vs. Prod)
// =============================================================================
// Prüft, ob die Anwendung lokal im Browser aufgerufen wird.
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

// Wenn wir lokal entwickeln (React auf Port 3000), leiten wir API-Calls an den Node-Server auf 3098.
// In der Docker-Produktion (wo Nginx/Node alles ausliefern) nutzen wir den relativen Pfad ('').
const API_URL = isLocalhost ? 'http://localhost:3098' : '';

// Erstellt eine neue axios-Instanz mit der dynamischen URL.
const apiClient = axios.create({
  baseURL: API_URL
});

// =============================================================================
//  AXIOS INTERCEPTOR (Sicherheit & JWT-Token)
// =============================================================================
// Diese Middleware feuert BEVOR eine Anfrage das Frontend verlässt.
apiClient.interceptors.request.use(
  (config) => {
    // Wir prüfen, ob im LocalStorage des Browsers Benutzerdaten (inkl. Token) liegen.
    const userInfo = localStorage.getItem('userInfo');
    
    if (userInfo) {
      // Token extrahieren und in den Authorization-Header im Bearer-Format einfügen.
      const { token } = JSON.parse(userInfo);
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Falls vor dem Senden ein Fehler auftritt, wird dieser direkt weitergegeben.
    return Promise.reject(error);
  }
);

// =============================================================================
//  API-FUNKTIONEN (Beispiele aus deinem Code, jetzt geschützt)
// =============================================================================

// API-Funktion zum Umbenennen eines Spielers.
export const renamePlayer = async (playerId, nameData) => {
  try {
    const { data } = await apiClient.put(`/api/players/${playerId}/rename`, nameData);
    return data;
  } catch (error) {
    console.error("Fehler beim Umbenennen des Spielers:", error.response?.data?.message || error.message);
    throw error;
  }
};

// API-Funktion zum Ändern der Wertung einer Nennung.
export const reclassifyEntry = async (entryId, classification) => {
  try {
    const { data } = await apiClient.put(`/api/entries/${entryId}/reclassify`, { classification });
    return data;
  } catch (error) {
    console.error("Fehler beim Ändern der Wertung:", error.response?.data?.message || error.message);
    throw error;
  }
};

// API-Funktion zum Ändern der Wertung einer Mannschaft.
export const reclassifyTeam = async (teamId, classification) => {
  try {
    const { data } = await apiClient.put(`/api/teams/${teamId}/reclassify`, { classification });
    return data;
  } catch (error) {
    console.error("Fehler beim Ändern der Mannschafts-Wertung:", error.response?.data?.message || error.message);
    throw error;
  }
};

export default apiClient;